
import ApiActions from '../../../actions/api';
import Constants from './constants';
import Store from './store';

class Actions {
  static sendMessage(data) {

    ApiActions.post(
      '/v1/contactCryptoPayment',
      data,
      Store,
      Constants.SEND_MESSAGE,
      Constants.SEND_MESSAGE_RESPONSE
    );
  }

  static resetStore() {

    Store.dispatch({ type: Constants.RESET_STORE });
  }
}


export default Actions;



// WEBPACK FOOTER //
// ./client/pages/main/contactCryptoPayment/actions.js